/*
 * Paginação padrão das tabelas do administrativo (5 linhas). O DataTable do
 * shared só usa os callbacks padrão quando `paginateOptions` é omitido; ao
 * passar o objeto, onChangePage/onChangeRowsPerPage precisam existir, senão
 * trocar de página ou filtrar lança TypeError.
 */
export const PAGINACAO_PADRAO = {
    rowsPerPage: 5,
    startPage: 0,
    resetPageOnRowsChange: true,
    onChangePage: () => {},
    onChangeRowsPerPage: () => {}
};

export const TEXTO_CARREGANDO = 'Carregando...';

/*
 * Texto da tabela vazia: enquanto a lista carrega mostra "Carregando..." (o
 * BlockUI fica por cima), e não "Nenhum registro", que só vale com a resposta.
 */
export const textoSemRegistros = (carregando, texto = 'Nenhum registro encontrado.') => (carregando ? TEXTO_CARREGANDO : texto);
